import { default as LoginCode } from './LoginCode'
import { default as Loading } from './Loading'
import { default as Table } from "./TableWrapper";
import { default as TableFilterPresets } from "./TableFilterPresets";
import { default as ConditionalWrapper } from "./ConditionalWrapper";

const Shared = {
    LoginCode,
    Table,
    Loading,
    TableFilterPresets,
    ConditionalWrapper,
}

export default Shared